/**
 * File: activityReports.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ActivityReportsController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}
            //Object - Basic academic details
        let academicDet = localStorageService.get("authoringData");
        let academics = {
            school_id: academicDet.school_id,
            batch_id: academicDet.batch_id,
            curriculum_id: academicDet.curriculum_id,
            subject_id: academicDet.subject_id,
            session_id: academicDet.session_id,
            class_id: academicDet.class_id,
            academic_year: academicDet.academic_year
        }

        //String - Teaching plan id
        let tpId = $state.params.planId

        //Boolean - Activity created or not
        $scope.isActivityCreated = false

        /*
         * Function to get assigned users
         * 
         */
        authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function(response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    $scope.isLoading = false

                    $scope.studentList = response.result.data.data;
                    //To sort student list
                    $scope.studentList.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function() {
                    $scope.$apply();
                });
            }
        });

        authService.callAPI(TPWIZARDCONSTANT.API_GET_ALL_ACTIVITY + tpId, "GET", {}, function(response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    $scope.isLoading = false
                    $scope.isActivityCreated = true
                    $scope.activityList = response.result.data.data;
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function() {
                    $scope.$apply();
                });
            } 
        });


        /*
         * Function to go to single activity based report
         * 
         * @id : String - Id of the question paper
         * 
         * @return : null
         *
         */
        $scope.gotoActivityReport = (id) => {
            $state.go("singleActivityReports", {
                prevParams: $state.params,
                qpId: id
            })
        }

        /*
         * Function to go to single student based report
         * 
         * @id : String - Id of the question paper
         * 
         * @return : null
         *
         */
        $scope.gotoStudentReport = (id) => {
            $state.go("studentActivityReports", {
                prevParams: $state.params,
                studentId: id,
                isShowGoBack: true
            })
        }

    };
}

export default ActivityReportsController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/reports/activityReports.js